import { useEffect, useState } from "react";
import { adminApi } from "../../lib/api";
import { TrendingUp, Package, Users, MessageCircle, Vote, Crown, Loader2 } from "lucide-react";

const formatEuro = (v) => `${v.toFixed(2).replace(".", ",")} €`;

const StatCard = ({ icon: Icon, label, value, sub, bg = "bg-amyu-cream", testid }) => (
  <div data-testid={testid} className={`${bg} rounded-[28px] p-6`}>
    <Icon className="text-coral" size={18} />
    <div className="font-display text-3xl mt-3 leading-none">{value}</div>
    <div className="text-xs uppercase tracking-[0.18em] text-amyu-muted mt-2">{label}</div>
    {sub && <div className="text-xs text-amyu-muted mt-1">{sub}</div>}
  </div>
);

export default function AdminStats() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminApi
      .get("/admin/stats")
      .then((r) => setStats(r.data))
      .finally(() => setLoading(false));
  }, []); // one-shot fetch on mount; adminApi is a stable module import

  if (loading)
    return (
      <div className="flex items-center justify-center py-20">
        <Loader2 className="animate-spin text-coral" />
      </div>
    );
  if (!stats) return null;

  return (
    <div data-testid="admin-stats-page">
      <h1 className="font-display text-4xl">Tableau de bord</h1>
      <p className="text-amyu-muted mt-2">Aperçu de l'activité Amyu en temps réel.</p>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-8">
        <StatCard
          testid="stat-revenue-day"
          icon={TrendingUp}
          label="CA aujourd'hui"
          value={formatEuro(stats.day.revenue)}
          sub={`${stats.day.count} commande${stats.day.count > 1 ? "s" : ""}`}
          bg="bg-amyu-pink"
        />
        <StatCard
          testid="stat-revenue-week"
          icon={TrendingUp}
          label="CA 7 jours"
          value={formatEuro(stats.week.revenue)}
          sub={`${stats.week.count} commande${stats.week.count > 1 ? "s" : ""}`}
          bg="bg-amyu-vanilla"
        />
        <StatCard
          testid="stat-revenue-month"
          icon={TrendingUp}
          label="CA 30 jours"
          value={formatEuro(stats.month.revenue)}
          sub={`${stats.month.count} commande${stats.month.count > 1 ? "s" : ""}`}
          bg="bg-amyu-pistachio"
        />
        <StatCard
          testid="stat-pending"
          icon={Package}
          label="À traiter"
          value={stats.pending_orders}
          sub="Commandes en attente"
          bg="bg-amyu-mango"
        />
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-4">
        <StatCard testid="stat-club" icon={Users} label="Cloud Club" value={stats.club_members} bg="bg-white" />
        <StatCard testid="stat-contacts" icon={MessageCircle} label="Messages" value={stats.contacts} bg="bg-white" />
        <StatCard testid="stat-votes" icon={Vote} label="Votes Lab" value={stats.lab_votes} bg="bg-white" />
        {stats.top_product && (
          <StatCard
            testid="stat-top-product"
            icon={Crown}
            label={`★ ${stats.top_product.name}`}
            value={`×${stats.top_product.quantity}`}
            sub="Top produit toutes commandes"
            bg="bg-white"
          />
        )}
      </div>
    </div>
  );
}
